import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { getBranchWiseDoctorStats, getDoctorAdminStats, getDoctorCenters, getDoctorDashboardFinancialData, getDoctorPatientsGraph, getHudDoctorDashboard, getHudDoctorHudData, getHudDoctorHudViewData } from '../../services/doctor/doctor_view_dashboard';
import { toast } from 'react-toastify';
import BarChart from '../../components/BarChart';
import { GiMedicinePills } from 'react-icons/gi';
import { FaHands, FaUserDoctor } from 'react-icons/fa6';
import { FiPackage } from 'react-icons/fi';
import PieChart from '../../components/tables/PieChart';
import { BiRefresh, BiSolidLock, BiUserCheck } from 'react-icons/bi';
import { CiSettings } from 'react-icons/ci';
import { BsGearFill } from 'react-icons/bs';
import { MdOutlineMedicalServices } from 'react-icons/md';
import MapComponent from '../../components/MapComponent/MapComponent';
import blueMachine from "../../assets/icons/map_blue.png";
import hudMachine from "../../assets/icons/map_hud.png";
import { RiMedicineBottleFill } from 'react-icons/ri';
import { TbMedicineSyrup } from 'react-icons/tb';
import { IoMedicalOutline } from 'react-icons/io5';
import Dropdown from '../../components/inputFields/DropDown';
import { Link } from 'react-router-dom';
import { RxCountdownTimer } from 'react-icons/rx';
import { PiInvoice } from 'react-icons/pi';
import BranchMonthlyPatientsChart from '../../components/BranchMonthlyPatientsChart';
import Button from '../../components/buttons/Button';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../../components/inputFields/CustomDatePicker';

function DoctorHome() {
    const [loading, setLoading] = useState(true);
    const [hudMachines, setHudMachines] = useState([]);
    const [patientsGraphData, setPatientsGraphData] = useState({});
    const [adminStatsData, setAdminStatsData] = useState([]);
    const [cardData, setCardData] = useState([
        {
            title: "Total Consultation Amount",
            total_amount: "--",
            total_count: "--",
            icon: <FaUserDoctor color='blue' size={34} />,
        },
        {
            title: "Total Package Amount",
            total_amount: "--",
            total_count: "--",
            icon: <FiPackage color='purple' size={34} />,
        },
        {
            title: "Total Medicine Amount",
            total_amount: "--",
            total_count: "--",
            icon: <GiMedicinePills color='red' size={34} />,
        },
    ]);
    const [hudCardData, setHudCardData] = useState([
        {
            title: "Total Patients",
            count: "--",
            icon: <BiUserCheck color='blue' size={34} />,
        },
        {
            title: "Total Machines",
            count: "--",
            icon: <BsGearFill color='purple' size={34} />,
        },
        {
            title: "Total Completed Doses",
            count: "--",
            icon: <RiMedicineBottleFill color='red' size={34} />,
        },
        // {
        //     title: "Monthly Avg. Dose",
        //     count: "--",
        //     icon: <GiMedicinePills color='red' size={34} />,
        // },
        {
            title: "Personal Avg. Dose",
            count: "--",
            icon: <TbMedicineSyrup color='red' size={34} />,
        },
        {
            title: "Current Month Comp. Dose",
            count: "--",
            icon: <IoMedicalOutline color='red' size={34} />,
        },
    ]);

    const [graphData, setGraphData] = useState({});
    const [hudData, setHudData] = useState([]);
    const [filterDays, setFilterDays] = useState(null);

    const fetchDashboard = async (value, filters) => {
        try {
            let res = await getHudDoctorDashboard(value, filters);
            if (res.status === 200) {
                setGraphData(res.data.last_7_days_center_data);
            } else {
                toast.error("Unable to fetch Dashboard");
            }
        } catch (error) {
            console.error("Unable to fetch Dashboard", error);
        }
    };

    const fetchDashboardFinances = async ({ branch, filters }) => {
        try {
            let res = await getDoctorDashboardFinancialData({
                branch: branch,
                filters: filters
            });
            if (res.status === 200) {
                setCardData(
                    [
                        {
                            title: "Total Package Amount",
                            total_amount: res.data.stats[0].value,
                            total_count: res.data.stats[0].count,
                            icon: <FiPackage color='purple' size={34} />,
                        },
                        {
                            title: "Total Medicine Amount",
                            total_amount: res.data.stats[2].value,
                            total_count: res.data.stats[2].count,
                            icon: <GiMedicinePills color='red' size={34} />,
                        },
                        {
                            title: "Total Consultation Amount",
                            total_amount: res.data.stats[1].value,
                            total_count: res.data.stats[1].count,
                            icon: <FaUserDoctor color='blue' size={34} />,
                        },
                    ]
                );
            } else {
                toast.error("Unable to fetch Dashboard Finances");
            }
        } catch (error) {
            console.error("Unable to fetch Dashboard Finances", error);
        }
    };

    const fetchPatientsGraphData = async () => {
        try {
            let res = await getDoctorPatientsGraph();
            if (res.status === 200) {
                setPatientsGraphData(res.data);
            } else {
                toast.error("Unable to fetch Patient Graph");
            }
        } catch (error) {
            console.error("Unable to fetch Patient Graph", error);
        }
    };

    const fetchAdminStatsData = async (filters) => {
        try {
            let res = await getDoctorAdminStats(filters);
            if (res.status === 200) {
                setAdminStatsData(res.data.stats);
            } else {
                toast.error("Unable to fetch Patient Graph");
            }
        } catch (error) {
            console.error("Unable to fetch Patient Graph", error);
        }
    };

    const fetchBranchWiseStatsData = async ({ branch, filters = "" }) => {
        try {
            let res = await getBranchWiseDoctorStats({ branch: branch, filters: filters });
            if (res.status === 200) {
                setAdminStatsData(res.data.stats);
            } else {
                toast.error("Unable to fetch Patient Graph");
            }
        } catch (error) {
            console.error("Unable to fetch Patient Graph", error);
        }
    };

    const fetchDashboardHudData = async () => {
        setLoading(true);
        try {
            let res = await getHudDoctorHudData();
            if (res.status === 200) {
                var d = res.data.center_data;
                d.push({ latitude: 43.6532, longitude: -79.3832, center: "Toronto HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 22.7196, longitude: 75.8577, center: "Indore HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 19.8347, longitude: 75.8816, center: "Jalna HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 18.6584, longitude: 72.8773, center: "Alibag HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 21.3701, longitude: 74.2403, center: "Nandurbar HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 19.0760, longitude: 72.8777, center: "Mumbai HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 25.4683, longitude: 81.8546, center: "Prayagraj HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 26.8467, longitude: 80.9462, center: "Lucknow HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 26.1158, longitude: 91.7086, center: "Guwahati HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 17.686815, longitude: 83.218483, center: "Visakhapatnam HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 20.9320, longitude: 77.7523, center: "Amravati HUD", icon: hudMachine, machines: [] });
                d.push({ latitude: 23.0753, longitude: 70.1337, center: "Gandhidham HUD", icon: hudMachine, machines: [] });
                setHudData(d);
                setLoading(false);
            } else {
                toast.error("Unable to fetch HUD");
            }
        } catch (error) {
            console.error("Unable to fetch HUD", error);
        }
    };

    const fetchDashboardHudViewData = async () => {
        try {
            let res = await getHudDoctorHudViewData();
            if (res.status === 200) {
                const data = res.data;
                setHudCardData([
                    {
                        title: "Total Patients",
                        count: data.total_patients,
                        icon: <BiUserCheck color='blue' size={34} />,
                    },
                    {
                        title: "Total Machines",
                        count: data.total_machines,
                        icon: <BsGearFill color='purple' size={34} />,
                    },
                    {
                        title: "Total Completed Doses",
                        count: data.total_completed_dose,
                        icon: <RiMedicineBottleFill color='red' size={34} />,
                    },
                    {
                        title: "Personal Avg. Dose",
                        count: data.person_average_dose,
                        icon: <TbMedicineSyrup color='red' size={34} />,
                    },
                    {
                        title: "Current Month Comp. Dose",
                        count: data.current_month_completed_dose,
                        icon: <IoMedicalOutline color='red' size={34} />,
                    },
                    {
                        title: "Monthly Invoice Count",
                        count: data.total_invoices_count,
                        icon: <RxCountdownTimer color='red' size={34} />,
                    },
                    {
                        title: "Monthly Invoice Sun",
                        count: data.total_invoices_sum,
                        icon: <PiInvoice color='red' size={34} />,
                    },
                ]);

            } else {
                toast.error("Unable to fetch HUD");
            }
        } catch (error) {
            console.error("Unable to fetch HUD", error);
        }
    };

    useEffect(() => {
        fetchDashboard("", "");
        fetchDashboardFinances({ branch: selectedCenter ?? "", filters: "" });
        fetchDashboardHudData();
        fetchDashboardHudViewData();
        fetchPatientsGraphData();
        fetchAdminStatsData("");
        fetchCenters();
    }, []);

    const getTypeIcon = (type) => {
        switch (type) {
            case 'DOOR LOCK':
                return <BiSolidLock color="#8b008b" size={20} />; // Dark Magenta
            case 'HFT':
                return <FaHands color="#007bff" size={20} />; // Blue
            case 'TPT':
                return <CiSettings color="#9400d3" size={20} />; // Dark Violet
            case 'Clinic':
                return <MdOutlineMedicalServices color="#ff6347" size={20} />; // Tomato Red
            default:
                return <BsGearFill color="#5a329d" size={20} />; // Deep Purple
        }
    };

    const [centers, setCenters] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(null);
    const [isYesterday, setIsYesterday] = useState(false);
    const [dateFilter, setDateFilter] = useState("");

    const handleDaysFilter = (value) => {
        setDateFilter(value);
        fetchDashboard(value, null);
    };

    const handleDateFilter = (value) => {
        setDateFilter(value);
        fetchDashboardFinances({ branch: selectedCenter ?? "", filters: `&date=${value}` });
        fetchBranchWiseStatsData({ branch: selectedCenter, filters: `&date=${value}` });
        setIsYesterday(false);
    };

    const handleYesterdayFilter = () => {
        fetchAdminStatsData(`?yesterday=${!isYesterday}`);
        fetchDashboardFinances({ branch: selectedCenter ?? "", filters: `&yesterday=${!isYesterday}` });
        fetchBranchWiseStatsData({ branch: selectedCenter, filters: `&yesterday=${!isYesterday}` });
        setIsYesterday(!isYesterday);
        setDateFilter(null);
    };

    const fetchCenters = async () => {
        try {
            let res = await getDoctorCenters("?page_size=50");
            if (res.status === 200) {
                setCenters(res.data.results);
            } else {
                toast.error("Unable to fetch centers");
            }
        } catch (error) {
            console.error("Error fetching centers:", error);
        }
    };

    const handleCenterChange = (value) => {
        setSelectedCenter(value);
        fetchBranchWiseStatsData({ branch: value, filters: `&date=${dateFilter ?? ""}&yesterday=${isYesterday}` });
        fetchDashboardFinances({ branch: value, filters: `&date=${dateFilter ?? ""}&yesterday=${isYesterday}` });
    };

    const handleClearFilter = () => {
        setDateFilter(null);
        setIsYesterday(false);
        fetchAdminStatsData(null);
        fetchBranchWiseStatsData({ branch: selectedCenter, filters: "" });
        fetchDashboardFinances({ branch: selectedCenter, filters: "" });
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: "/doctor/home" },
        ]} />
        <div className="py-2">
            <div className="flex flex-row justify-between items-center">
                <StyledHeadingText text={"Admin Stats"} size={"text-sm"} />

                <div className="flex flex-row gap-2">

                    <CustomDatePicker
                        placeholder={"Select Date"}
                        onChange={handleDateFilter}
                        value={dateFilter}
                    />

                    <div className="flex flex-row items-center">
                        <Button
                            children="Yesterday"
                            onClick={handleYesterdayFilter}
                            className={`${isYesterday ? "bg-primary text-white" : "bg-white text-black"} border-2 border-primary rounded-md text-xs`}
                        />
                    </div>

                    <Dropdown
                        placeholder={selectedCenter || "Select Center"}
                        name="center"
                        options={centers.map((center) => ({
                            value: center.name,
                            label: center.name,
                        }))}
                        onChange={handleCenterChange}
                        className="text-black"
                        needSearch
                        required
                    />

                    {
                        (dateFilter !== "" && dateFilter !== null || isYesterday) && (
                            <Button
                                children={"Clear"}
                                onClick={handleClearFilter}
                                className="text-primary font-bold"
                            />
                        )
                    }
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mt-2 mb-4">
                {adminStatsData.map((card, index) => (
                    <Link to={card.clickable ? `/new-hud-filtered-patients?date=${dateFilter ?? ""}&yesterday=${isYesterday}` : null} state={{ ...card, center: selectedCenter }} className={`${card.clickable ? "" : "cursor-default"}`}>
                        <div className={`relative p-4 bg-white shadow-md rounded-lg overflow-hidden ${card.clickable ? "hover:shadow-md" : ""}`}>
                            <h3 className="text-sm font-semibold text-[#6B7280]">{card.title}</h3>
                            <hr />
                            <p className="text-lg font-bold">{card.value}</p>
                            {card.icon && (
                                <div className="absolute bottom-2 right-2 opacity-55 text-4xl">
                                    <img src={card.icon} alt={card.icon} className='object-contain h-8' />
                                </div>)}
                        </div>
                    </Link>
                ))}
            </div>

            <StyledHeadingText text={"Today's Summary"} size={"text-sm"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mt-2 mb-4">
                {cardData.map((card, index) => (
                    <div className="relative p-4 bg-white shadow-md rounded-lg overflow-hidden">
                        <h3 className="text-sm font-semibold text-[#6B7280]">{card.title}</h3>
                        <hr />
                        <p className="text-lg font-bold">₹ {card.total_amount}</p>
                        <p className="text-[0.6rem]">Count: {card.total_count}</p>

                        {/* Add the icon at the bottom-right with opacity */}
                        <div className="absolute bottom-2 right-2 opacity-35 text-4xl">
                            {card.icon}
                        </div>
                    </div>
                ))}
            </div>

            <BranchMonthlyPatientsChart data={patientsGraphData} />

            <div className="flex flex-row justify-end">
                <Dropdown onChange={handleDaysFilter}
                    placeholder='7 Days'
                    options={[
                        // { label: "7 Days", value: "7", },
                        { label: "15 Days", value: "15", },
                        { label: "30 Days", value: "30", },
                    ]} /></div>

            <div className="flex flex-col xl:flex-row gap-2">
                <div className="p-4 shadow rounded-lg bg-white mt-4 xl:max-w-[18rem]">
                    <StyledHeadingText size={"text-sm"} text={"Medicine"} />
                    <hr className='mt-2 mb-4 border-primary' />
                    <PieChart data={graphData} selectedKey={"medicine_amount"} />
                </div>
                <div className="p-4 shadow rounded-lg bg-white mt-4 flex-1">
                    <StyledHeadingText size={"text-sm"} text={`Last ${filterDays || 7} Days Center Data`} />
                    <hr className='mt-2 mb-4 border-primary' />
                    <BarChart data={graphData} />
                </div>
            </div>
        </div>

        <StyledHeadingText text={"HUD Stats"} size={"text-sm"} />
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-4 my-2">
            {hudCardData.map((card, index) => (
                <div className="relative p-4 bg-white shadow-md rounded-lg overflow-hidden">
                    <h3 className="text-sm font-semibold text-[#6B7280]">{card.title}</h3>
                    <hr />
                    <p className="text-lg font-bold">{card.count}</p>

                    {/* Add the icon at the bottom-right with opacity */}
                    <div className="absolute bottom-2 right-2 opacity-35 text-4xl">
                        {card.icon}
                    </div>
                </div>
            ))}
        </div>

        <StyledHeadingText size={"text-sm"} text={"Machines (Today)"} />
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-2 mt-2">
            {hudData.map((center) => {
                if (center.icon) return <></>;

                const visibleMachines = center.machines.filter(
                    (machine) => machine.type?.toUpperCase() !== "DOOR LOCK"
                );

                return (
                    <Link to="/doctor/home/invoice" state={center.center} className='h-full w-full'>
                        <div
                            key={center.center}
                            className="bg-white rounded-lg shadow-md p-4 flex flex-col h-full w-full"
                        >
                            {/* Center Header */}
                            <div className="border-b pb-2 mb-2">
                                <h2 className="text-sm font-bold text-gray-800">
                                    {center.center}
                                    <span className="ml-2 text-sm font-normal text-gray-500">
                                        ({visibleMachines.length} machines)
                                    </span>
                                </h2>
                            </div>
                            {/* Machine List */}
                            <div className="flex flex-col gap-1">
                                {visibleMachines.map((machines, index) => (
                                    <div key={index} className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            {getTypeIcon(machines.type)}
                                            <span className="ml-2 text-sm">{machines.type} ({parseInt(machines.total_operated_time)})</span>
                                        </div>
                                        <div
                                            className={`w-6 h-2 rounded-full ${machines.type !== "Clinic" ? machines.is_power ? "bg-green-500" : "bg-red-500" : "bg-white"}`}
                                        >
                                            {machines.is_power ? (
                                                <span className="text-white text-xs font-bold">On</span>
                                            ) : (
                                                <span className="text-white text-xs font-bold">Off</span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Link>
                );
            })}
        </div>
        <div className="rounded-lg shadow-lg mt-4 p-4 bg-white">
            <MapComponent
                markersList={
                    hudData.map((center) => ({ lat: center.latitude, lng: center.longitude, label: center.center, icon: center.icon || blueMachine }))
                }
                height='25rem'
                zoomLevel={3}
            />
        </div>
    </>);
}

export default DoctorHome;